import React from "react";
import QaiChallengeContainer from "../Shared/QaiChallengeContainer";

export default function TeamLeaderQaiChallengeContainer() {
    return (
        <QaiChallengeContainer view="Team Leader" />
    )
}